import $ from 'jquery';
require('magnific-popup');

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';

function initImageGallery() {
  const storeSelector = '.js-img-store';
  const $store = $(storeSelector);

  if (!$store.length) return;

  $store.magnificPopup({
    type: 'image',
    store: {
      enabled: true
    }
  });
}

function initImage() {
  const imageSelector = '.js-img';
  const $image = $(imageSelector);

  if (!$image.length) return;

  $image.magnificPopup({
    type: 'image'
  });
}

function initGallery() {
  const gallery = document.querySelector('.js-gallery');
  if (!gallery) return;

  const linkSelector = '.js-gallery-link';

  const lightbox = new PhotoSwipeLightbox({
    gallery: gallery,
    children: linkSelector,
    pswpModule: PhotoSwipe
  });

  lightbox.init();
}

export {initGallery, initImage, initImageGallery};
